import React from 'react';
import MainLayOut from '../layout/MainLayOut';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination, Autoplay } from "swiper/modules";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const About = () => {
  return (
    <MainLayOut>
      <div>
        <div className='py-16 md:py-24 text-base md:text-lg px-4 md:px-8 lg:px-12 xl:px-20'>
          <h1 className='font-semibold text-3xl md:text-4xl text-gray-800 mb-8'>
            Let's start with <span className='border-b-4 border-black'>Our Story</span>
          </h1>

          <div className='grid grid-cols-1 xl:grid-cols-2 gap-8 items-center'>
            <LazyLoadImage alt="our-story" className='w-full rounded-md' src="images/bucket.png" />
            <div>
              <p className='text-xl font-semibold mb-2'>It all starts with name</p>
              <h2 className='uppercase font-bold text-lg mb-4'>MPI Virgin Plastic</h2>
              <p className='leading-relaxed'>
                MPI Virgin Plastic is committed to offering premium, eco-friendly plastic products, designed to meet the needs of modern living. From our durable plastic planters to storage containers and buckets, our products are crafted with the highest quality materials, ensuring long-lasting durability and functionality.<br /><br />
                Our journey began with a simple mission: to provide affordable, high-quality plastic goods that not only serve practical purposes but also contribute to a cleaner and more sustainable environment. We focus on virgin plastic materials, ensuring that every product is free from impurities and built to last.<br /><br />
                At MPI Virgin Plastic, we believe in creating products that blend innovation, style, and functionality. Whether you're looking for a planter for your garden, a container for storage, or a sturdy bucket for everyday use, we have you covered.
              </p>
            </div>
          </div>
        </div>

        <div className='bg-surface-dark text-white text-center px-4 py-24 md:py-32 text-3xl md:text-4xl font-semibold leading-snug'>
          Revolutionizing Everyday Essentials: The Power of <br /> <strong>Quality, Durability, and Sustainability</strong>
        </div>

        <div className='max-w-screen-xl mx-auto py-20 md:py-28 text-lg md:text-xl space-y-4 px-4 md:px-0'>
          <h3 className='font-medium text-xl'>OUR VISION</h3>
          <p>Building a sustainable future, one plastic product at a time.</p>
          <p className='md:w-2/3'>
            The dream behind MPI Virgin Plastic began with the idea of creating products that combine both style and utility. Our founder, recognizing the growing need for durable, sustainable plastic products, set out to create a brand that focuses on high-quality plastic goods for the everyday consumer. At MPI, we believe that quality plastic products should be accessible to everyone, and we are committed to providing just that, with an emphasis on durability and functionality.
          </p>
        </div>

        <img alt='about-banner' loading="lazy" className='w-full h-[300px] md:h-[450px] object-cover' src='images/partition-banner.jpg' />

        <div className='max-w-screen-xl mx-auto py-20 text-lg md:text-xl px-4 md:px-0 space-y-6 '>
          <p>
            At MPI Virgin Plastic, we view plastic not just as a material, but as a versatile solution that enhances everyday living. By focusing on creating functional, durable, and eco-friendly plastic products, we aim to transform the way people think about plastic. Our commitment to quality ensures that every product we offer not only meets but exceeds customer expectations.
          </p>
          <p>
            Whether it's creating the perfect plastic planter to showcase your plants or offering reliable storage solutions, we take pride in the products we craft. With an eye on innovation, we are constantly evolving to provide better, more sustainable options for our customers.
          </p>
        </div>

        <div className='px-4 md:px-0 max-w-screen-xl mx-auto py-20 text-lg md:text-xl'>
          <p>
            MPI Virgin Plastic™ was founded in 2021, with a core belief in providing high-quality, sustainable plastic products that stand the test of time.<br /><br />
            <span className='text-3xl md:text-4xl font-medium'>
              With the vision of <br />
              <span className='font-bold'>Durability, Sustainability, and Style.</span>
            </span><br /><br />
            That’s what <span className='font-bold'>MPI Virgin Plastic™</span> stands for.<br /><br />
            <div className='text-4xl md:text-5xl mb-6'>
              Changing the Way We Use Plastic: <span className='font-semibold'>Practical, Eco-Friendly Solutions</span>
            </div>
          </p>
        </div>

        <div className='grid md:grid-cols-3 text-center text-3xl md:text-5xl font-medium mb-20 gap-8'>
          <div>
            <span>4 Years</span><br />
            <span className='text-lg md:text-xl font-normal'>In the Plastic Industry</span>
          </div>
          <div>
            <span>50 +</span><br />
            <span className='text-lg md:text-xl font-normal'>Products Offered</span>
          </div>
          <div>
            <span>500K+</span><br />
            <span className='text-lg md:text-xl font-normal'>Satisfied Customers Worldwide</span>
          </div>
        </div>

        <div className='bg-surface-dark/40 text-white px-4 md:px-8 py-16 md:py-24'>
          <h2 className='text-3xl md:text-4xl font-bold text-center mb-10'>What Makes Us Unique?</h2>
          <Swiper
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            modules={[Pagination, Autoplay]}
            className="w-full h-52"
          >
            <SwiperSlide>
              <div className="text-center text-base md:text-lg px-6">
                All our products are made from 100% virgin plastic for guaranteed strength and durability.
              </div>
              <div className="text-center font-semibold mt-4">Eco-Friendly Focus</div>
              <div className="text-center mt-2">
                We use sustainable manufacturing practices to minimize waste and environmental impact.
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="text-center text-base md:text-lg px-6">
                Designed for longevity, our planters, buckets, and containers are built to last for years.
              </div>
              <div className="text-center mt-2">
                We offer a range of sizes and styles to suit all your needs, from gardening to storage.
              </div>
              <div className="text-center mt-2">
                Free shipping on all orders above $50.
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="text-center text-lg p-6">Join the movement towards a cleaner, more sustainable future. 🌍</div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </MainLayOut>
  );
};

export default About;
